import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import { DateTime } from 'luxon'

import {
  Container,
  LogDataContainer,
  ActionBlock,
  Column,
  TextRow,
  SubTitle,
  InfoText
} from './styles'

export default function AuditLogDetailsModal ({
  visible,
  auditLog,
  onClose: handleClose = () => null
}) {
  if (!auditLog) return null

  function formatJson (json) {
    try {
      return JSON.stringify (JSON.parse (json), null, 2)
    } catch {
      return json
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='lg' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Detalhes do registro</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <TextRow>
              <SubTitle>Data e hora:</SubTitle>
              <InfoText>
                {DateTime.fromISO (auditLog.created_at).toFormat ('dd/MM/yyyy - HH:mm')}
              </InfoText>
            </TextRow>
            <TextRow>
              <SubTitle>Autor:</SubTitle>
              <InfoText>
                {auditLog.user?.name || 'Usuário Desconhecido'}
              </InfoText>
            </TextRow>
            <TextRow style={{ marginBottom: 1 }}>
              <SubTitle>Item:</SubTitle>
              <InfoText>{auditLog.table_name_readable}</InfoText>
            </TextRow>
            <TextRow style={{ alignItems: 'center' }}>
              <SubTitle>Ação:</SubTitle>
              <ActionBlock action={auditLog.action}>
                <InfoText>{auditLog.action_readable}</InfoText>
              </ActionBlock>
            </TextRow>
            {auditLog.old_data && (
              <Column>
                <SubTitle>Dados antigos:</SubTitle>
                <LogDataContainer>
                  {formatJson (auditLog.old_data)}
                </LogDataContainer>
              </Column>
            )}
            {auditLog.new_data && (
              <Column>
                <SubTitle>Dados novos:</SubTitle>
                <LogDataContainer>
                  {formatJson (auditLog.new_data)}
                </LogDataContainer>
              </Column>
            )}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
